import axios from 'axios';
import { uintStream, commit } from '../../lib/keno-vendor/engine.mjs';
import { KENO_API, gameHeaders } from '../keno/fairnessApi';

export const calculateBlackjackCards = async (serverSeed, clientSeed, nonce) => (await uintStream(serverSeed, clientSeed, nonce, 52)).map((value) => Math.floor(value / 4294967296 * 52));

export const verifyBlackjackRound = async (round, demo) => {
  const { data } = await axios.get(`${KENO_API}/keno/${demo ? 'demo/' : ''}fairness/reveal/${round.seed_id}`, { headers: { ...gameHeaders(demo), 'X-GV-Currency': round.currency || 'v' } });
  const hash = await commit(data.server_seed);
  if (hash !== round.server_seed_hash) throw new Error('The revealed server seed does not match the committed hash.');
  const cards = await calculateBlackjackCards(data.server_seed, round.client_seed, round.nonce);
  if (!round.finished || !round.drawn || JSON.stringify(cards.slice(0, round.drawn.length)) !== JSON.stringify(round.drawn)) throw new Error('The dealt-card sequence does not match this bet.');
  return { hash, seed: data.server_seed, cards: round.drawn };
};